module.exports = __webpack_public_path__ + "img/total_guest.e412fc74.svg";